import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  List,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { Autocomplete as MUIAutocomplete } from "@mui/material";

import { Autocomplete } from "@react-google-maps/api";
import AddIcon from "@mui/icons-material/Add";
import * as Yup from "yup";
import { imgWatermark, UploadMedia, Uploadpdf, UploadVideo } from "../../utils/uploadMedia";
import { errorToast, successToast, warnToast } from "../../helpers/toast";
import { generateEncryptedKeyBody } from "../../utils/crypto";

import { useFormik } from "formik";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CommonBody, PropertyType, PropertyValues } from "../../types/General";
import {
  useEditPropertyMutation,
  useLazyGetSpecificPropertyByIdQuery,
  usePostAddPropertyMutation,
  useLazyGetAmenitiesListingQuery,
  useLazyGetpropertyTypeOffplanListingQuery,
} from "../../services/property";

import { useLazyGetAllCategoriesQuery, useLazyGetAllCategoryQuery } from "../../services/category";
import Loader from "../../helpers/constants/Loader";
import {
  useLazyGetAllTypeOfCompaniesQuery,
  useLazyGetPendingAgentQuery,
} from "../../services/users";
import { useLazyGetAllpropertyStatusQuery } from "../../services/propertyStatus";
import moment from "moment";
import { isNumberPrice } from "../../utils/validation";
import DragAndDrop from "../../components/DragAndDrop";
import EditText from "../../components/EditText";
import { AGENCY_TYPE, ROLE } from "../../constants/enums";

const AddProperty = () => {
  const [ByIdDetails, setByIdDetails] = useState<PropertyValues | any>();
  const [isLoading, setLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const { _id } = useParams();
  const [waterMark, setWaterMark] = useState<string>("")
  const [description, setDescription] = useState<string>("");

  const today = new Date().toISOString().split("T")[0];
  const [addProperties] = usePostAddPropertyMutation();
  const [updateProperty] = useEditPropertyMutation();
  const [fetchApi] = useLazyGetSpecificPropertyByIdQuery();
  const [propertyTypeList] = useLazyGetpropertyTypeOffplanListingQuery();
  const [amenitiesTypeList] = useLazyGetAmenitiesListingQuery();
  const [fieldsArray, setFieldsArray] = useState<any>([]);
  
  const [propertyTypeId, setPropertyType] = useState<
    { _id: string; name: string }[]
  >([]);

  const [categories, setCategories] = useState<{ _id: string; name: string }[]>(
    []
  );
  const [amennity, setAmenity] = useState<{ _id: string; name: string }[]>([
    {
      _id: "",
      name: "",
    },
  ]);
  const [interiorImages, setInteriorImages] = useState<string[]>([]);
  const [exteriorImages, setExteriorImages] = useState<string[]>([]);
  const [gardenImages, setGardenImages] = useState<string[]>([]);
  const imageHandlers = [setInteriorImages, setExteriorImages, setGardenImages];
  const imageMap: { [key in 0 | 1 | 2]: string[] } = {
    0: interiorImages,
    1: exteriorImages,
    2: gardenImages,
  };
  const [getAllSubcategory] = useLazyGetAllCategoriesQuery();

  const [subCategories, setSubCategories] = useState<any>([]);
  const [places, setPlaces] = useState<any[]>([]);
  const [value, setValue] = useState<number>(0);
  const images = imageMap[value as 0 | 1 | 2] || interiorImages;
  const setImages = imageHandlers[value];
  const [getApprovedAgents] = useLazyGetPendingAgentQuery();
  const [agentsData, setAgentsData] = useState([]);
  const [selectedAgentId, setSelectedAgentId] = useState("");
  const [uploadedImages, setUploadedImages] = useState<string[]>([]);
  const [companyListingApi] = useLazyGetAllTypeOfCompaniesQuery();
  const [companyListing, setCompanyListing] = useState<any>([]);
  const [companyId, setCompanyId] = useState<string>("");
  const [autocomplete, setAutocomplete] = useState<any>();
  const [rows, setRows] = useState<PropertyType[]>([]);
  const [fetchAll] = useLazyGetAllpropertyStatusQuery();
  const [fetchAllCategory] = useLazyGetAllCategoryQuery();
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [rentType, setRentType] = useState<string>("")
  const handlePropertyTypeChange = (item: any) => {
    if (item?._id) {
      formik.setFieldValue("propertyTypeId", item._id);
    }
    setFieldsArray(item?.optionsArray || [])
  };

  const handleAmenities = (event: SelectChangeEvent<string[]>) => {
    if (event?.target?.value) {
      formik.setFieldValue("amenitiesId", event.target?.value);
    }
  };

  const handleCheques = (event: SelectChangeEvent<number[]>) => {
    //console.log('event :', event.target.value);
    if (event?.target?.value) {
      formik.setFieldValue("noOfCheque", event.target?.value);
    }
  };

  const handlePropertyCondition = (event: SelectChangeEvent) => {
    formik.setFieldValue("propertyCondition", event.target?.value);
  };


  const fetchCategories = async () => {
    try {
      const response = await fetchAllCategory({
        limit: 100,
        page: 1,
        search: "",
        type: "category",
        parentId: "",
      }).unwrap();
      setCategories(response?.data?.category || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const fetchSubCatgeories = async () => {
    try {
      const response = await getAllSubcategory({
        type: "subcategory",
        parentId: formik.values.category || "",
        limit: 100
      }).unwrap();
      setSubCategories(response?.data?.category || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };


  const handlePdfUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;
    if (file && file.type !== "application/pdf") {
      warnToast("Please upload a PDF file.");
      return;
    }
    try {
      if (!file) {
        formik.setFieldValue("floorPlan", null);
        return;
      }
      let res;
      res = await Uploadpdf(file);
      if (res?.statusCode === 200) {
        formik.setFieldValue("floorPlan", res?.data?.[0]?.location); // Assuming pdfUrl is the URL of the uploaded PDF
      } else {
        errorToast(res?.message);
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      errorToast("Error uploading file. Please try again.");
    }
  };

  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {

    const files = event.target.files;
    const allowedLength = Array.from(files || []).length;
    if (Array.from(files || []).length > 20) {
      errorToast('Max limit is upto 20 images');
      event.target.value = '';
      return;
    }

    const allowedTypes = ['image/png', 'image/jpeg', 'image/jpg'];
    const allowedVideoTypes = ['video/mp4', 'video/avi', 'video/mkv'];
    const invalidFiles = Array.from(files || []).filter(
      (file) =>
        !allowedTypes.includes(file.type) &&
        !allowedVideoTypes.includes(file.type),
    );
    if (invalidFiles.length > 0) {
      errorToast('Inavlid  type');
      event.target.value = '';
      return;
    }

    if (
      interiorImages.length +
      exteriorImages.length +
      gardenImages.length +
      allowedLength >
      20
    ) {
      errorToast('Max limit is upto 20 images');
      event.target.value = '';
      return;
    }

    const videoFiles = Array.from(files || []).filter((file) =>
      allowedVideoTypes.includes(file.type),
    );

    let validVideos = true;

    await Promise.all(
      videoFiles?.map(
        (file) =>
          new Promise<void>((resolve) => {
            const videoElement = document.createElement('video');
            videoElement.preload = 'metadata';

            videoElement.onloadedmetadata = function () {
              window.URL.revokeObjectURL(videoElement.src);
              if (videoElement.duration > 120) {
                validVideos = false;
                errorToast('Video duration exceeds the limit of 2 minutes');
              }
              resolve();
            };

            videoElement.src = URL.createObjectURL(file);
          }),
      ),
    );

    if (!validVideos) {
      event.target.value = '';
      return;
    }

    setLoading(true);
    const resArray = await Promise.all(
      Array.from(files || [])?.map(async (file) => {
        if (allowedTypes.includes(file.type)) {
          try {

            const watermarkedImage = await imgWatermark(
              file,
              waterMark,
            );
            setLoading(false);
            return UploadMedia(watermarkedImage);
          } catch (error: any) {
            errorToast("Something went wrong")
            setLoading(false);
          }
        } else if (allowedVideoTypes.includes(file.type)) {
          return UploadVideo(file);
        }
        return null;
      }),
    );


    resArray?.map((res) => {
      if (res?.statusCode === 200) {

        const { location } = res?.data[0];

        if (imageHandlers[value]) {
          imageHandlers[value]((prev) => [...prev, location]);
        }
        setLoading(false);

        event.target.value = '';
        return;

      } else {
        errorToast(res?.message as string);
        setLoading(false);
        event.target.value = '';
      }
    });
  };


  const fetchLocations = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}common/locations.json`,
      );
      const data = await response.json();
      const arr = data?.map((item: { key: any; value: any }) => ({
        label: item?.value,
        value: item?.key || "",
      }));
      setPlaces(arr);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const [searchParams, setSearchParams] = useSearchParams();
  const onLoad = (autocompleteObj: any) => {
    setAutocomplete(autocompleteObj);
  };
  const onPlaceChanged = async () => {
    if (autocomplete) {
      let place = await (autocomplete as any)?.getPlace();

      if (place && place?.address_components) {
        let address = place?.address_components;

        let state,
          city,
          country,
          zip = "";

        address?.forEach(function (component: any) {
          let types = component?.types;

          if (
            types?.indexOf("locality") > -1 ||
            types?.indexOf("administrative_area_level_3") > -1
          ) {
            city = component?.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component?.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });
        var lat = place?.geometry?.location?.lat();
        var lng = place?.geometry?.location?.lng();
        formik.setFieldValue("address", place?.formatted_address);
        formik.setFieldValue("latitude", lat || 0);
        formik.setFieldValue("longitude", lng || 0);
      }
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const fetchDataById = async (id: any) => {
    try {
      const response = await fetchApi({
        userId: id,
        isDraft: Boolean(searchParams?.get("draft")),
      }).unwrap();
      if (response.statusCode === 200) {
        setByIdDetails(response?.data || []);
        setDescription(response?.data?.specifications);
        setFieldsArray(response?.data?.propertyTypeId?.optionsArray||[])
      }
    } catch (error: any) {
      console.error(error);
    }
  };



  const fetchPropertyType = async () => {
    try {
      const response = await propertyTypeList({
        isOffPlanProjects: false,
        agencyType: 1
      }).unwrap();
      setPropertyType(response?.data || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const fetchAmenities = async () => {
    try {
      const response = await amenitiesTypeList({}).unwrap();
      setAmenity(response?.data || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const List = async (search: string) => {
    try {
      const response = await fetchAll({ search: search }).unwrap();
      setRows(response?.data?.PropertyCondition || []);
    } catch (e: any) {
      errorToast(e?.message || e?.data?.message);
    }
  };

  const handleDateChange = (event: any) => {
    formik.setFieldValue("availableDateFrom", event.target.value);
    const selectedDate = new Date(event.target.value);
    if (!isNaN(selectedDate.getTime())) {
      const utcDate = moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss[Z]')

      setStartDate(utcDate);
    } else {
      console.error("Invalid date selected");
    }
  };

  const handleCrossClick = (e: React.MouseEvent, i: number) => {
    e.stopPropagation();
    let res = [...imageMap[value as 0 | 1 | 2]];
    res?.splice(i, 1);
    imageHandlers[value]([...res]);
  };

  const handleDateChange1 = (event: any) => {
    formik.setFieldValue("availableDateTo", event.target.value);
    const selectedDate = new Date(event.target.value);
    if (!isNaN(selectedDate.getTime())) {
      const utcDate = moment(selectedDate).format('YYYY-MM-DDTHH:mm:ss[Z]')

      setEndDate(utcDate);
    } else {
      console.error("Invalid date selected");
    }
  };

  function formatNumberWithCommas(value: string | number) {
    const valueStr = typeof value === 'number' ? value.toFixed(2) : value;
    const [integer, decimal] = valueStr.split('.');
    const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    let result = decimal !== undefined ? `${formattedInteger}.${decimal}` : formattedInteger;
    return result;
  }

  const formik = useFormik({
    initialValues: {
      name: "",
      price: "",
      address: "",
      specifications: "",
      beds: "",
      baths: "",
      advertisementPermitNo: "",
      category: "",
      propertyCondition: "",
      amenitiesId: [],
      latitude: 0,
      longitude: 0,
      propertyTypeId: "",
      area: "",
      companyName: "",
      agentName: "",
      agentId: "",
      companyId: "",
      size: "",
      availableDateTo: "",
      availableDateFrom: "",
      serviceCharges: "",
      finacialStatus: "",
      floorPlan: "",
      titleDeed: "",
      furnishedType: "",
      country: "",
      noOfCheque: [],
      subCategory: "",
      subCategoryName: ""
    },

    validationSchema: Yup.object().shape({
      // name: Yup.string().required("Property Name is required"),
      // titleDeed: Yup.string().required("Title deed is required"),
      // price: Yup.string()
      //   .required("Price is required")
      //   .max(10, "Price must be less than 10 characters"),
      // address: Yup.string().required("Address is required"),
      // area: Yup.string().required("Area is required"),
      // // specifications: Yup.string().required("Description is required"),
      // propertyCondition: Yup.string().required(
      //   "Please select Property Condition"
      // ),
      // furnishedType: Yup.string().required("Please select furnished type"),
      // companyName: Yup.string().required("Please select a company"),
      // propertyTypeId: Yup.string().required("Please select Property Type"),
      // category: Yup.string().required("Category is required"),
      // country: Yup.string().required("Please Select city"),
      // subCategory: Yup.string().required("Sub Category is required"),
      // amenitiesId: Yup.array()
      //   .min(1, "Please select amenity")
      //   .required("Amenities are required"),

      // beds: Yup.number().required("Number of Beds is required"),
      // baths: Yup.number().required("Number of Baths is required"),
      // advertisementPermitNo: Yup.string(),


      // serviceCharges: Yup.string(),
      // floorPlan: Yup.string(),
      // finacialStatus: Yup.string(),
      // availableDateFrom: Yup.string(),
      // availableDateTo: Yup.string(),
    }),

    onSubmit: async (values: any) => {
      formik.setSubmitting(true);

      if (!companyId) {
        warnToast("Please select an Company")
        return;
      }
      if (interiorImages?.length + exteriorImages?.length + gardenImages?.length < 3) {
        warnToast("Please Upload minimum 3 Images")
        return;
      }



      // if (!selectedAgentId) {
      //   warnToast("Please select an agent")
      //   return;
      // }


      const body: any = {};

      if (values?.name) {
        body.name = values.name;
      }
      if (values?.price) {
        body.price = Number(String(values.price).replace(/,/g, ''));
      }
      if (values?.address) {
        body.address = values.address;
      }
      if (description?.length > 7) {
        body.specifications = description;
      }

      if (values?.beds) {
        body.beds = values.beds;
      }
      if (values?.baths) {
        body.baths = values.baths;
      }
      if (values?.advertisementPermitNo && values.city==='dubai') {
        body.advertisementPermitNo = values.advertisementPermitNo;
      }
      if (values?.area) {
        body.area = values.area;
      }
      if (values?.category) {
        body.categoryParentId = values.category;
      }
      if (values?.country) {
        body.locationId = values.country;
      }
      if (values?.subCategory) {
        body.categoryId = values.subCategory;
      }

      if (interiorImages?.length) {
        body.interior = interiorImages;
      }
      if (exteriorImages?.length) {
        body.exterior = exteriorImages;
      }
      if (gardenImages?.length) {
        body.garden = gardenImages;
      }
      if (values?.propertyCondition) {
        body.propertyConditionId = values.propertyCondition;
      }
      if (values?.amenitiesId) {
        body.amenitiesId = values.amenitiesId;
      }
      if (values?.latitude) {
        body.latitude = values.latitude;
      }
      if (values?.longitude) {
        body.longitude = values.longitude;
      }
      if (values?.propertyTypeId) {
        body.propertyTypeId = values.propertyTypeId;
      }
      if (companyId) {
        body.companyId = companyId;
      }
      if (selectedAgentId) {
        body.agentId = selectedAgentId;
      }

      if (values?.availableDateTo) {
        body.availableDateTo = endDate;
      }
      if (values?.availableDateFrom) {
        body.availableDateFrom = startDate;
      }
      if (values?.serviceCharges) {
        body.serviceCharges = values.serviceCharges;
      }
      if (values?.finacialStatus) {
        body.finacialStatus = Number(values.finacialStatus);
      }

      if (values?.floorPlan) {
        body.floorPlan = values.floorPlan;
      }
      if (values.furnishedType) {
        body.furnished = Number(values.furnishedType)
      }
      if (values.noOfCheque) {
        body.longTermRentType = values.noOfCheque
      }

      if (values.titleDeed) {
        body.titleDeed = values.titleDeed
      }
      body.isAssignedToAgent = true;
      body.images = [
        ...interiorImages,
        ...exteriorImages,
        ...gardenImages,
      ]

      if (searchParams.get("draft")) {
        body["draftId"] = _id;
      }

      // console.log(body, "body");

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      try {
        if (!_id || Boolean(searchParams.get("draft"))) {
          const response = await addProperties(encryptedBody).unwrap();
          if (response?.statusCode === 200) {
            successToast("Properties Added Successfully.");
            navigate("/property-listing");
          }
        } else {
          const response = await updateProperty({
            id: _id,
            body: encryptedBody,
          }).unwrap();
          if (response?.statusCode === 200) {
            successToast("Property Updated Successfully.");
            navigate("/property-listing");
          }
        }
      } catch (error: any) {
        errorToast(error?.data?.message);
      } finally {
        formik.setSubmitting(false);
      }
    },
  });
  console.log(formik.values.country, "formik.values.country");

  const saveDraft = async () => {

    if (interiorImages?.length + exteriorImages?.length + gardenImages?.length < 3) {
      warnToast("Please Upload minimum 3 Images")
      return;
    }


    const values = formik?.values;
    const body: any = {};

    if (values?.name) {
      body.name = values.name;
    }
    if (values?.price) {
      body.price = Number(String(values.price).replace(/,/g, ''));
    }
    if (values?.address) {
      body.address = values.address;
    }
    if (description?.length > 7) {
      body.specifications = description;
    }

    if (values?.beds) {
      body.beds = values.beds;
    }
    if (values?.baths) {
      body.baths = values.baths;
    }
    if (values?.advertisementPermitNo) {
      body.advertisementPermitNo = values.advertisementPermitNo;
    }
    if (values?.area) {
      body.area = values.area;
    }
    if (values?.category) {
      body.categoryParentId = values.category;
    }
    if (values?.country) {
      body.locationId = values.country;
    }
    if (values?.subCategory) {
      body.categoryId = values.subCategory;
    }

    if (interiorImages?.length) {
      body.interior = interiorImages;
    }
    if (exteriorImages?.length) {
      body.exterior = exteriorImages;
    }
    if (gardenImages?.length) {
      body.garden = gardenImages;
    }
    if (values?.propertyCondition) {
      body.propertyConditionId = values.propertyCondition;
    }
    if (values?.amenitiesId) {
      body.amenitiesId = values.amenitiesId;
    }
    if (values?.latitude) {
      body.latitude = values.latitude;
    }
    if (values?.longitude) {
      body.longitude = values.longitude;
    }
    if (values?.propertyTypeId) {
      body.propertyTypeId = values.propertyTypeId;
    }
    if (companyId) {
      body.companyId = companyId;
    }
    if (selectedAgentId) {
      body.agentId = selectedAgentId;
    }

    if (values?.availableDateTo) {
      body.availableDateTo = endDate;
    }
    if (values?.availableDateFrom) {
      body.availableDateFrom = startDate;
    }
    if (values?.serviceCharges) {
      body.serviceCharges = values.serviceCharges;
    }
    if (values?.finacialStatus) {
      body.finacialStatus = Number(values.finacialStatus);
    }

    if (values?.floorPlan) {
      body.floorPlan = values.floorPlan;
    }
    if (values.furnishedType) {
      body.furnished = Number(values.furnishedType)
    }
    if (values.noOfCheque) {
      body.longTermRentType = values.noOfCheque
    }

    if (values.titleDeed) {
      body.titleDeed = values.titleDeed
    }
    body.isAssignedToAgent = true;
    body.images = [
      ...interiorImages,
      ...exteriorImages,
      ...gardenImages,
    ]

    // Always set isDraftSaved to true
    body.isDraftSaved = true;



    const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

    try {
      if (!_id) {
        const response = await addProperties(encryptedBody).unwrap();
        if (response?.statusCode === 200) {
          successToast("Properties drafted successfully.");
          navigate("/property-listing");
        }
      } else {
        const response = await updateProperty({
          id: _id,
          body: encryptedBody,
        }).unwrap();
        if (response?.statusCode === 200) {
          successToast("Property drafted successfully.");
          navigate("/property-listing");
        }
      }
    } catch (error: any) {
      errorToast(error?.data?.message);
    } finally {
      formik.setSubmitting(false);
    }
  };

  const fetchApproved = async () => {
    setLoading(true);
    try {
      const response = await getApprovedAgents({
        page: 1,
        search: "",
        limit: 200,
        parentId: companyId,
        isAdminAprooved: 2,
        startDate: "",
        endDate: "",
      }).unwrap();
      if (response.statusCode === 200) {
        setLoading(false);
        setAgentsData(response?.data?.user);
        if (!response?.data?.user?.length)
          warnToast("This company dont have any agents");
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  //console.log(formik.values.propertyTypeId, "formik.values.propertyTypeId ");

  const fetchCompanyListing = async () => {
    try {
      const res = await companyListingApi({
        role: ROLE.AGENCY,
        agencyType: AGENCY_TYPE.REAL_ESTATE_BROKER,
      }).unwrap();
      if (res?.statusCode === 200) {
        setCompanyListing(res?.data);
      }
    } catch (error: any) {
      //console.log(error?.data?.message);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchAmenities();
    fetchPropertyType();
    List("");
    fetchLocations();
    fetchCompanyListing();
  }, []);



  useEffect(() => {
    if (_id) fetchDataById(_id);
  }, [_id]);

  useEffect(() => {
    if (formik.values.category) fetchSubCatgeories()
  }, [formik.values.category])


  useEffect(() => {
    if (ByIdDetails) {
      // @ts-ignore
      formik.setValues({
        name: ByIdDetails?.name || "",
        price: ByIdDetails?.price ? formatNumberWithCommas(String(ByIdDetails?.price)) : "",
        address: ByIdDetails?.address || "",
        specifications: ByIdDetails?.specifications || "",
        propertyCondition: ByIdDetails?.propertyConditionId || "",
        propertyTypeId: ByIdDetails?.propertyTypeId?._id || "",
        category: ByIdDetails?.categoryParentId?._id || "",
        subCategory: ByIdDetails?.categoryId?._id || "",
        country: ByIdDetails?.locationId || "",
        area: ByIdDetails?.area,
        titleDeed: ByIdDetails?.titleDeed || "",
        amenitiesId:
          ByIdDetails?.amenities?.map((item: { _id: any }) => item?._id) || [],
        beds: ByIdDetails?.beds || "",
        baths: ByIdDetails?.baths || "",
        advertisementPermitNo: ByIdDetails?.advertisementPermitNo || "",
        latitude: ByIdDetails?.latitude || 0,
        longitude: ByIdDetails?.longitude || 0,
        companyName: ByIdDetails?.companyId?._id || "",
        agentName: ByIdDetails?.agentId?.name || "",
        size: ByIdDetails?.size || "",
        serviceCharges: ByIdDetails?.serviceCharges || "",
        // buildingName: ByIdDetails?.buildingName || "",
        floorPlan: ByIdDetails?.floorPlan || "",
        availableDateTo:
          moment(ByIdDetails?.availableDateTo).format("YYYY-MM-DD") || "",
        availableDateFrom:
          moment(ByIdDetails?.availableDateFrom).format("YYYY-MM-DD") || "",
        finacialStatus: ByIdDetails?.finacialStatus || "",
      });
      setSelectedAgentId(ByIdDetails?.agentId?._id || "");
      setCompanyId(ByIdDetails?.companyId?._id || "");
      setUploadedImages(ByIdDetails?.images || []);
      setInteriorImages(ByIdDetails?.interior || [])
      setExteriorImages(ByIdDetails?.exterior || [])
      setGardenImages(ByIdDetails?.garden || [])
    }
  }, [ByIdDetails]);


  useEffect(() => {
    if (companyId) {

      fetchApproved();

    }
  }, [companyId]);


  return (
    <div>
      <Loader isLoad={isLoading} />
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{_id ? "Edit Property" : "Add Property"}</h1>
          <Button
            className="btn btn_primary"
            onClick={() =>
              navigate(
                "/property-listing" +
                (Boolean(searchParams.get("draft")) ? "?draft=true" : ""),
                { replace: true }
              )
            }
          >
            Back
          </Button>
        </div>
        <Card className="cards">
          <form onSubmit={formik.handleSubmit}>
            <CardContent sx={{ p: 1 }}>
              <Grid container spacing={2}>


                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Typography className="custom_label">Select Company</Typography>
                  {/* <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="companyName"
                    fullWidth
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250, // Adjust height
                          // width: 250,     // Adjust width
                        },
                      },
                    }}
                    value={companyListing?.length ? formik?.values?.companyName : ""}
                    onChange={(e) =>
                      formik.setFieldValue("companyName", e.target?.value)
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.companyName &&
                      Boolean(formik.errors?.companyName)
                    }
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    {companyListing?.length &&
                      companyListing?.map((item: any) => {
                        return (
                          <MenuItem
                            onClick={() => { setWaterMark(item?.image); setCompanyId(item?._id) }}
                            value={item?._id}
                          >
                            {item?.companyName + " (" + item?.referenceId + ")"}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  {formik.touched?.companyName &&
                    formik.errors?.companyName && (
                      <Typography
                        sx={{ fontSize: "12px" }}
                        variant="caption"
                        color="red"
                      >
                        Please select a company
                      </Typography>
                    )} */}
                  <MUIAutocomplete
                    options={companyListing || []}
                    getOptionLabel={(option: any) => option?.companyName + " (" + option?.referenceId + ")" || ""}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Select Company"
                        variant="outlined"
                        fullWidth
                        error={
                          formik.touched?.companyName &&
                          Boolean(formik.errors?.companyName)
                        }
                        onBlur={formik.handleBlur}
                        name="companyName"
                      />
                    )}
                    value={
                      companyListing?.find(
                        (item: any) =>
                          item?._id === companyId
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      formik.setFieldValue(
                        "companyName",
                        newValue?.companyName || ""
                      );
                      setCompanyId(newValue?._id || "");
                      setWaterMark(newValue?.image || '')
                    }}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option?._id === value?._id
                    }
                  />
                </Grid>
                {agentsData?.length ? (
                  <Grid item lg={6} md={6} sm={12} xs={12}>
                    <Typography className="custom_label">
                      Assign Agent
                    </Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      // disabled={_id ? true : false}
                      name="agentName"
                      fullWidth
                      value={agentsData?.length ? formik?.values?.agentName : ""}
                      onChange={(e) =>
                        formik.setFieldValue("agentName", e.target?.value)
                      }
                      onBlur={formik.handleBlur}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            // width: 250,     // Adjust width
                          },
                        },
                      }}
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {agentsData?.length &&
                        agentsData?.map((item: any) => {
                          return (
                            <MenuItem
                              onClick={() => setSelectedAgentId(item?._id)}
                              value={item?._id}
                            >
                              {item?.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </Grid>
                ) : (
                  ""
                )}
                <Grid item xs={12}>
                  <Box className="custom_tabs">
                    <Tabs
                      value={value}
                      onChange={handleChange}
                      variant="scrollable"
                      scrollButtons="auto"
                      aria-label="basic tabs example"
                      className="custom_tabs_links"
                    >
                      <Tab label="Interior Images" />
                      <Tab label="Exterior Images" />
                      <Tab label="Garden Images" />
                    </Tabs>
                    <Box className="upload_images_container">
                      <div className="upload_image upload_property">
                        <div className="gap_p">
                          <DragAndDrop
                            myImages={images}
                            setMyImages={setImages}
                            handleCrossClick={handleCrossClick}
                          />

                          {images?.length < 20 ? (
                            <label
                              htmlFor="icon-button-file"
                            >
                              <Input
                                sx={{ display: 'none' }}
                                id="icon-button-file"
                                type="file"
                                inputProps={{
                                  accept: 'image/*,video/*',
                                  multiple: true,
                                }}
                                onChange={handleImageUpload}
                                disabled={!companyId ? true : false}
                              />
                              <span className="upload_image_holder">
                                <AddIcon />
                                Upload Picture/Video
                              </span>
                            </label>
                          ) : null}
                        </div>
                      </div>
                    </Box>
                  </Box>
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Property Name
                  </Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="name"
                    className="text_field"
                    variant="outlined"
                    fullWidth

                    placeholder="Enter Property Name"
                    value={formik?.values?.name}
                    onChange={(val) => {
                      if (
                        val.target.value === " "

                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.name && Boolean(formik.errors.name)}
                    helperText={
                      formik.touched.name &&
                        typeof formik.errors.name === "string"
                        ? formik.errors.name
                        : undefined
                    }
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Title deed
                  </Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="titleDeed"
                    className="text_field"
                    variant="outlined"

                    fullWidth
                    placeholder="Title deed"
                    value={formik?.values?.titleDeed}
                    onChange={(val) => {
                      if (
                        val.target.value === " "

                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.titleDeed && Boolean(formik.errors.titleDeed)}
                    helperText={
                      formik.touched.titleDeed &&
                        typeof formik.errors.titleDeed === "string"
                        ? formik.errors.titleDeed
                        : undefined
                    }
                  />
                </Grid>
                

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Price</Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}

                    name="price"
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    placeholder="Enter Price"
                    value={formik?.values?.price}
                    onChange={(val) => {
                      let { value } = val.target;
                      const numericValue = value.replace(/,/g, '');
                      if (
                        isNumberPrice(numericValue) &&
                        numericValue.length <= 12
                      ) {
                        const formattedValue =
                          formatNumberWithCommas(numericValue);
                        formik.setFieldValue('price', formattedValue);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.price && Boolean(formik.errors.price)}
                    helperText={
                      formik.touched.price &&
                        typeof formik.errors.price === "string"
                        ? formik.errors.price
                        : undefined
                    }
                  />
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">Category</Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="category"
                      value={categories?.length ? formik?.values?.category : ""}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      error={
                        formik.touched.category &&
                        Boolean(formik.errors.category)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {categories?.length > 0
                        ? categories?.map((category: any) => (
                          <MenuItem key={category?._id} value={category?._id}>
                            {category?.name}
                          </MenuItem>
                        ))
                        : ""}
                    </Select>
                    {formik.touched?.category && formik.errors?.category && (
                      <Typography
                        sx={{ fontSize: "12px" }}
                        variant="caption"
                        color="red"
                      >
                        Please select a category
                      </Typography>
                    )}
                  </FormControl>
                </Grid>

                <Grid item lg={4} md={6} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">Sub-Category</Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="subCategory"
                      value={subCategories?.length ? formik?.values?.subCategory || "" : ''}
                      // onChange={(e) => {
                      //   formik.setFieldValue('subCategory', e.target.value)
                      //   formik.setFieldValue('subCategoryName', e.target.value)
                      // }}
                      onChange={(e) => {
                        const selectedSubCategory = subCategories.find(
                          (sub: any) => sub._id === e.target.value
                        );
                        formik.setFieldValue("subCategory", selectedSubCategory?._id || "");
                        formik.setFieldValue("subCategoryName", selectedSubCategory?.name || "");
                      }}
                      onBlur={formik.handleBlur}
                      disabled={!formik.values.category}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      error={
                        formik.touched.subCategory &&
                        Boolean(formik.errors.subCategory)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {subCategories?.length
                        ? subCategories?.map((subCategory: any) => (
                          <MenuItem key={subCategory?._id} value={subCategory?._id}>
                            {subCategory?.name}
                          </MenuItem>
                        ))
                        : ""}
                    </Select>
                    {formik.touched?.subCategory && formik.errors?.subCategory && (
                      <Typography
                        sx={{ fontSize: "12px" }}
                        variant="caption"
                        color="red"
                      >
                        Please select a sub-Category
                      </Typography>
                    )}
                  </FormControl>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">
                    Furnished Type
                  </Typography>
                  <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="furnishedType"
                    fullWidth
                    value={formik?.values?.furnishedType || ""}
                    onChange={(e) =>
                      formik.setFieldValue("furnishedType", e.target?.value)
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.furnishedType &&
                      Boolean(formik.errors?.furnishedType)
                    }
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="1">Furnished</MenuItem>
                    <MenuItem value="2">Unfurnished</MenuItem>
                    <MenuItem value="3">Partly Furnished</MenuItem>
                  </Select>
                  {formik.touched.furnishedType &&
                    formik.errors.furnishedType && (
                      <FormHelperText sx={{ color: "red" }}>
                        {String(formik.errors.furnishedType)}
                      </FormHelperText>
                    )}
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Beds</Typography>
                  <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="beds"
                    fullWidth
                    value={formik?.values?.beds || ""}
                    onChange={(e) =>
                      formik.setFieldValue("beds", e.target?.value)
                    }
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250, // Adjust height
                          width: 250,     // Adjust width
                        },
                      },
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched?.beds && Boolean(formik.errors?.beds)}
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="0">{formik.values.subCategoryName === 'Apartment' ? "Studio" : "0"}</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                    <MenuItem value="6">6</MenuItem>
                    <MenuItem value="7">7+</MenuItem>
                  </Select>
                  {formik.touched.beds && formik.errors.beds && (
                    <FormHelperText sx={{ color: "red" }}>
                      {String(formik.errors.beds)}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Bathrooms</Typography>
                  <Select
                    className="select_div"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="baths"
                    fullWidth
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 250, // Adjust height
                          width: 250,     // Adjust width
                        },
                      },
                    }}
                    value={formik?.values?.baths || ""}
                    onChange={(e) =>
                      formik.setFieldValue("baths", e.target?.value)
                    }
                    onBlur={formik.handleBlur}
                    error={
                      formik.touched?.baths && Boolean(formik.errors?.baths)
                    }
                    displayEmpty
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    <MenuItem value="0">0</MenuItem>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                    <MenuItem value="6">6</MenuItem>
                    <MenuItem value="7">7+</MenuItem>
                  </Select>
                  {formik.touched.baths && formik.errors.baths && (
                    <FormHelperText sx={{ color: "red" }}>
                      {String(formik.errors.baths)}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">
                      Property Type
                    </Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="propertyTypeId"
                      value={propertyTypeId?.length ? formik?.values?.propertyTypeId : ""}
                      // onChange={handlePropertyTypeChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.propertyTypeId &&
                        Boolean(formik.errors?.propertyTypeId)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {propertyTypeId?.length > 0
                        ? propertyTypeId?.map((it: any) => (
                          <MenuItem key={it?._id} value={it?._id} onClick={() => { setRentType(it?.name); handlePropertyTypeChange(it) }} >
                            {it?.name}
                          </MenuItem>
                        ))
                        : ""}
                    </Select>

                    {formik.touched?.propertyTypeId &&
                      typeof formik?.errors?.propertyTypeId === "string" && (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          variant="caption"
                          color="red"
                        >
                          {formik.errors?.propertyTypeId}
                        </Typography>
                      )}
                  </FormControl>
                </Grid>
                {rentType?.includes("Rent") || rentType?.includes("rent") ? (
                  <>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <FormControl fullWidth>
                        <Typography className="custom_label">
                          Rent Type
                        </Typography>
                        <Select
                          className="select_div"
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          name="propertyTypeId"
                          value={""}
                          onBlur={formik.handleBlur}
                          displayEmpty
                        >

                          <MenuItem value={""} disabled >
                            Yearly
                          </MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item lg={4} md={4} sm={6} xs={12}>
                      <Typography className="custom_label">Number of Cheque</Typography>
                      <Select
                        className="select_div"
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        name="noOfCheque"
                        fullWidth
                        value={formik?.values?.noOfCheque || []}
                        onChange={handleCheques}
                        multiple
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250, // Adjust height
                              width: 250,     // Adjust width
                            },
                          },
                        }}
                        renderValue={(selected: any) =>
                          selected?.length > 0
                            ? selected
                              ?.map((value: any) => {

                                return `Cheque ${value}`;
                              })
                              .join(", ")
                            : "Select"
                        }
                        onBlur={formik.handleBlur}
                        error={formik.touched?.noOfCheque && Boolean(formik.errors?.noOfCheque)}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          Select
                        </MenuItem>
                        <MenuItem value={1}>Cheque 1</MenuItem>
                        <MenuItem value={2}>Cheque 2</MenuItem>
                        <MenuItem value={3}>Cheque 3</MenuItem>
                        <MenuItem value={4}>Cheque 4</MenuItem>

                      </Select>
                      {formik.touched.noOfCheque && formik.errors.noOfCheque && (
                        <FormHelperText sx={{ color: "red" }}>
                          {String(formik.errors.noOfCheque)}
                        </FormHelperText>
                      )}
                    </Grid>
                  </>
                ) : ("")}



                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">Amenities</Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      name="amenitiesId"
                      value={amennity?.length ? formik?.values?.amenitiesId : []}
                      onChange={handleAmenities}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.amenitiesId &&
                        Boolean(formik.errors?.amenitiesId)
                      }
                      displayEmpty
                      multiple
                      renderValue={(selected) =>
                        selected?.length > 0
                          ? selected
                            ?.map((value) => {
                              const amenity = amennity?.find(
                                (it) => it?._id === value
                              );
                              return amenity?.name;
                            })
                            .join(", ")
                          : "Select"
                      }
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {amennity?.length > 0
                        ? amennity?.map((it) => (
                          <MenuItem key={it?._id} value={it?._id}>
                            {it?.name}
                          </MenuItem>
                        ))
                        : ""}
                    </Select>
                    {formik.touched.amenitiesId &&
                      typeof formik.errors.amenitiesId === "string" && (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          variant="caption"
                          color="red"
                        >
                          {formik.errors.amenitiesId}
                        </Typography>
                      )}
                  </FormControl>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <FormControl fullWidth>
                    <Typography className="custom_label">
                      Property Status
                    </Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="propertyCondition"
                      value={rows?.length ? formik?.values?.propertyCondition : ""}
                      onChange={handlePropertyCondition}
                      onBlur={formik.handleBlur}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      error={
                        formik.touched.propertyCondition &&
                        Boolean(formik.errors.propertyCondition)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {rows?.length &&
                        rows?.map((data: any) => {
                          return (
                            <MenuItem value={data?._id}>{data?.name}</MenuItem>
                          );
                        })}
                    </Select>
                    {formik.touched.propertyCondition &&
                      typeof formik.errors.propertyCondition === "string" && (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          variant="caption"
                          color="red"
                        >
                          {formik.errors.propertyCondition}
                        </Typography>
                      )}
                  </FormControl>
                </Grid>





                {fieldsArray?.includes("financial_status") ? (
                  ""
                ) : (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Financial Status
                    </Typography>
                    <Select
                      className="select_div"
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="finacialStatus"
                      fullWidth
                      value={formik?.values?.finacialStatus || ""}
                      onChange={(e) =>
                        formik.setFieldValue("finacialStatus", e.target?.value)
                      }
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched?.finacialStatus &&
                        Boolean(formik.errors?.finacialStatus)
                      }
                      displayEmpty
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      <MenuItem value="1">Cash</MenuItem>
                      <MenuItem value="2">Mortgage</MenuItem>
                    </Select>
                    {formik.touched.finacialStatus &&
                      formik.errors.finacialStatus && (
                        <FormHelperText sx={{ color: "red" }}>
                          {String(formik.errors.finacialStatus)}
                        </FormHelperText>
                      )}
                  </Grid>
                )}

                {fieldsArray?.includes("property_available_from") ? (
                  ""
                ) : (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Available From
                    </Typography>
                    <TextField
                      // hiddenTypography
                      type="date"
                      name="availableDateFrom"
                      variant="outlined"
                      fullWidth
                      placeholder="Start date"
                      className="text_field"
                      inputProps={{ maxLength: 30 }}
                      value={formik.values.availableDateFrom}
                      onChange={handleDateChange}
                      InputProps={{
                        endAdornment: formik.values.availableDateFrom && (
                          <InputAdornment position="end" className="eye_btn">
                            <IconButton
                              onClick={() => {
                                setStartDate("");
                                formik.setFieldValue("availableDateFrom", "");
                              }}
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {formik.touched.availableDateFrom &&
                      formik.errors.availableDateFrom && (
                        <FormHelperText sx={{ color: "red" }}>
                          {String(formik.errors.availableDateFrom)}
                        </FormHelperText>
                      )}
                  </Grid>
                )}
                {fieldsArray?.includes("property_available_to") ? (
                  ""
                ) : (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Available to
                    </Typography>
                    <TextField
                      // hiddenTypography
                      type="date"
                      name="availableDateTo"
                      variant="outlined"
                      fullWidth
                      placeholder="End date"
                      className="text_field"
                      inputProps={{ maxLength: 30, min: today }}
                      value={formik.values.availableDateTo}
                      onChange={handleDateChange1}
                      InputProps={{
                        endAdornment: formik.values.availableDateTo && (
                          <InputAdornment position="end" className="eye_btn">
                            <IconButton
                              onClick={() => {
                                setEndDate("");
                                formik.setFieldValue("availableDateTo", "");
                              }}
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    {formik.touched.availableDateTo &&
                      formik.errors.availableDateTo && (
                        <FormHelperText sx={{ color: "red" }}>
                          {String(formik.errors.availableDateTo)}
                        </FormHelperText>
                      )}
                  </Grid>
                )}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <div className="control_group w_50">
                    <Typography className="custom_label">Address</Typography>
                    <Autocomplete
                      onLoad={onLoad}
                      onPlaceChanged={() => onPlaceChanged()}
                      options={{
                        types: ['establishment', 'geocode'], // Restrict to cities
                        componentRestrictions: { country: 'ae' },
                      }}
                    >
                      <TextField
                        className="text_field"
                        hiddenLabel
                        name="address"
                        value={formik?.values?.address || ""}
                        placeholder="Enter Address"
                        fullWidth
                        helperText={
                          formik.touched.address &&
                            typeof formik.errors.address === "string"
                            ? formik.errors.address
                            : undefined
                        }
                        onChange={(e) => {
                          if (
                            e.target?.value.trim() === "" ||
                            e.target?.value === "."
                          ) {
                            formik.setFieldValue("address", "");
                          } else {
                            formik.handleChange(e);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Autocomplete>
                  </div>
                </Grid>

                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <div className="control_group w_50">
                    <Typography className="custom_label">Select city</Typography >
                    <Select
                      labelId="category-label"
                      value={places?.length ? formik.values.country : ""}
                      id="category-select"
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 250, // Adjust height
                            width: 250,     // Adjust width
                          },
                        },
                      }}
                      name="country"
                      fullWidth
                      displayEmpty
                      onChange={(e) => {
                        formik.setFieldValue("country", e.target.value)
                      }}
                    >
                      <MenuItem value={''} disabled>
                        Select
                      </MenuItem>
                      {places?.length
                        ? places.map((item: any, index: number) =>
                          item?.value && item?.label ? (
                            <MenuItem value={item.value} key={index}>
                              {item.label}
                            </MenuItem>
                          ) : null // Skip items without value or label
                        )
                        : ""}
                    </Select>
                    {formik.touched.country && formik.errors.country && (
                      <FormHelperText sx={{ color: "red" }}>{String(formik.errors.country)}</FormHelperText>
                    )}
                  </div>
                </Grid>
                {formik.values.country === 'dubai' ? (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Advertisement Permit Number
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="advertisementPermitNo"
                      className="text_field"
                      variant="outlined"
                      fullWidth

                      disabled={_id ? true : false}
                      placeholder="Enter Advertisement Permit No "
                      value={formik?.values?.advertisementPermitNo}
                      onChange={(val) => {
                        if (
                          val.target.value === " "

                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.advertisementPermitNo &&
                        Boolean(formik.errors.advertisementPermitNo)
                      }
                      helperText={
                        formik.touched.advertisementPermitNo &&
                          typeof formik.errors.advertisementPermitNo === "string"
                          ? formik.errors.advertisementPermitNo
                          : undefined
                      }
                    />
                  </Grid>
                ) : ("")}
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <Typography className="custom_label">Area (Sq.ft)</Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="area"
                    className="text_field"
                    variant="outlined"
                    fullWidth
                    placeholder="Enter area"
                    value={formik?.values?.area}
                    onChange={(e) => {
                      const re = /^[0-9]*\.?[0-9]*$/;
                      if (e.target?.value === "" || re.test(e.target?.value)) {
                        formik.handleChange(e);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.area && Boolean(formik.errors.area)}
                    inputProps={{
                      inputMode: "decimal",
                    }}
                    helperText={
                      Boolean(formik.touched.area) &&
                      formik.errors.area?.toString()
                    }
                  />
                </Grid>

                {fieldsArray?.includes("service_charges") ? ("") : (
                  <Grid item lg={4} md={4} sm={6} xs={12}>
                    <Typography className="custom_label">
                      Service Charges
                    </Typography>
                    <TextField
                      hiddenLabel
                      type={"text"}
                      name="serviceCharges"
                      className="text_field"
                      variant="outlined"
                      fullWidth
                      placeholder="Enter Service Charges"
                      value={formik?.values?.serviceCharges}
                      onChange={(e) => {
                        const re = /^[0-9]*\.?[0-9]*$/;
                        if (e.target?.value === "" || re.test(e.target?.value)) {
                          formik.handleChange(e);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.serviceCharges &&
                        Boolean(formik.errors.serviceCharges)
                      }
                      inputProps={{
                        inputMode: "decimal",
                      }}
                      helperText={
                        Boolean(formik.touched.serviceCharges) &&
                        formik.errors.serviceCharges?.toString()
                      }
                    />
                  </Grid>
                )}




                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography className="custom_label">
                    Description
                  </Typography>

                  {description?.length || !_id ? <EditText
                    content={description}
                    setContent={setDescription}
                  /> : null}
                </Grid>
                {fieldsArray?.includes("floor_plan") ? ("") : (
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography className="custom_label">
                      Floor Plan (pdf format)
                    </Typography>
                    <Box className="upload_image upload_img_dpinf">
                      <label htmlFor="icon-button-file-vdo">
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file-vdo"
                          type="file"
                          inputProps={{
                            type: "file",
                            accept: "application/pdf",
                          }}
                          disabled={formik.values.floorPlan ? true : false}
                          onChange={handlePdfUpload}
                        />
                        <Button component="span" className="upload_image_btn">
                          <img
                            style={{
                              borderRadius: "5px",
                              width: "300px",
                              height: "200px",
                              border: "dashed 3px lightgrey",
                              objectFit: "contain",
                            }}
                            onClick={() =>
                              formik.values.floorPlan ? window.open(formik.values.floorPlan) : null
                            }
                            src={
                              formik.values.floorPlan
                                ? "/static/images/pdf.png"
                                : "/static/images/upload.png"
                            }
                            alt=""
                          />
                        </Button>
                      </label>
                      <div className="close_btn_abs">
                        {formik.values.floorPlan ? (
                          <IconButton
                            onClick={() => formik.setFieldValue("floorPlan", "")}
                          >
                            <ClearIcon />
                          </IconButton>
                        ) : (
                          ""
                        )}
                      </div>
                    </Box>
                    {formik.touched.floorPlan &&
                      typeof formik.errors.floorPlan === "string" && (
                        <Typography
                          sx={{ fontSize: "12px" }}
                          variant="caption"
                          color="red"
                        >
                          {formik.errors.floorPlan}
                        </Typography>
                      )}
                  </Grid>
                )}



              </Grid>
              <div className="form_btn">
                <Button type="submit" className="btn btn_primary">
                  Save
                </Button>
                {Boolean(searchParams?.get("draft")) && (
                  <Button className="btn btn_secondary" onClick={saveDraft}>
                    Save as draft
                  </Button>
                )}
                {!_id && (
                  <Button className="btn btn_secondary" onClick={saveDraft}>
                    Save as draft
                  </Button>
                )}
              </div>
            </CardContent>
          </form>
        </Card>

      </div>
    </div>
  );
};

export default AddProperty;
